// Dependencies
import styled, { css, keyframes } from 'styled-components';

type BackDropTypes = {
  visible: boolean;
};

type AnimatedTypes = {
  isOpen: boolean;
};

export const Backdrop = styled.div<BackDropTypes>`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
  position: fixed;
  /* 🔴 Sin justify-content/align-items center (2026-09-24, reportado en la
     Tab Active5): con ellos, una ventana MÁS ALTA que la pantalla —una tabla
     con los filtros desplegados, en vertical— desbordaba por igual arriba y
     abajo, y lo de arriba quedaba fuera del alcance del scroll: no había forma
     de subir. El centrado lo hace ahora margin:auto en AnimatedModal: reparte
     el hueco cuando la ventana cabe y se queda en 0 cuando no, así que la
     ventana arranca arriba y se baja con el scroll. */
  display: flex;
  padding: ${({ theme }) => theme.spacing.s} 0;
  backdrop-filter: blur(12px);
  transition: all 150ms linear;
  background: ${({ theme }) => theme.colors.greyBackground};
  overflow: auto;
  max-height: 100%;

  ${({ visible }) => `
    opacity: ${visible ? '1' : '0'};
    visibility: ${visible ? 'visible' : 'hidden'};
  `}
`;

const display = keyframes`
  from {
    transform: scale(0.9);
    visibility: hidden;
    opacity: 0;
  }
  to {
    transform: scale(1);
    visibility: visible;
    opacity: 1;
  }
`;

export const AnimatedModal = styled.div<AnimatedTypes>`
  /* Centrado seguro: ver Backdrop. */
  margin: auto;
  ${(props) =>
    props.isOpen &&
    css`
      animation: ${display} 0.3s ease-in-out;
    `}
`;
